import { FaGlobe, FaExternalLinkAlt } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, link, repo, skills }) => {


  const handleOpenLink = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  }

  return (
    <div className="w-full p-4 xl:px-12 h-auto xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000">
      <div className="w-full overflow-hidden rounded-lg">
        <img
          className="w-full h-60 object-contain group-hover:scale-110 duration-300 cursor-pointer broder border-red-600"
          src={src}
          alt="src"
          link={link}
          repo={repo}
        />
      </div>
      <div className="w-full mt-5 flex flex-col  gap-6">
        <h3 className="text-base uppercase text-designColor font-normal">
          {title}
        </h3>

        {/*desc*/}
        <p className="text-sm tracking-wide mt-3 h-[150px] hover:text-gray-100 duration-300">
          {des}
        </p>

        {/*skills*/}
        <div>
          {
            skills &&
            skills.map((skill, index) => (
              <span key={index} className="chips" title={"LinkedIn"}>
                {skill}
              </span>
            ))
            // <span className="buttons" title={"LinkedIn"}>
            //   {"React"}
            // </span>
          }
        </div>

        {/*links*/}
        <div className="gap-6 flex flex-row ">
          {/* <span className="text-lg w-10 h-10 rounded-full bg-black  inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
            <a href={repo} target={"_blank"} rel={"noreferrer"}>
              <BsGithub />
            </a>
          </span>
          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
            <a href={link} target={"_blank"} rel={"noreferrer"}>
              <FaGlobe />
            </a>
          </span> */}

          <button
            onClick={() => handleOpenLink(link)}
            disabled={!link}
            className="button gap-3 flex items-center disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaExternalLinkAlt size={16} /> <span>Live Demo</span>
          </button>

          {/* <div className="button gap-10">
            <a href={repo} target={"_blank"} rel={"noreferrer"} className="flex items-center gap-3">
            </a>
          </div> */}
          <button
            onClick={() => handleOpenLink(repo)}
            disabled={!repo}
            className="button gap-3 flex items-center disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaGlobe size={16} /> <span>View Code</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectsCard;